<template>
  <div style="height: 100%;">
    <!-- LOADING PART START -->
    <v-progress-linear height="4" :indeterminate="true" v-if="isLoading" style="margin: -2px;"></v-progress-linear>
    <v-tooltip top v-if="loadFailed">
      <v-btn slot="activator" flat icon color="error" @click="refresh(failed)">
        <v-icon>refresh</v-icon>
      </v-btn>
      Reload
    </v-tooltip>
    <!-- LOADING PART END -->

    <!-- SLOT (THE CHART) START -->
    <slot v-if="!loadFailed"></slot>
    <!-- SLOT (THE CHART) END -->

    <!-- FILTERS START -->
    <v-layout row class="overflow" v-if="!loadFailed">
      <slot name="filters"></slot>
      <v-dialog
        v-model="dialog"
        width="810"
      >
        <v-btn style="" flat color="grey" slot="activator">
          <v-icon>date_range</v-icon>
          {{ $vuetify.t('$vuetify.charts.timeRange') }}
        </v-btn>
        <date-range :callback-event="childUpdate"/>
      </v-dialog>
    </v-layout>
    <!-- FILTERS END -->
  </div>
</template>

<script>
import DateRange from '../Misc/DateRange'
const axios = require('axios')

export default {
  props: {
    failed: { // For when the parent wants to send a fail loading input
      type: Boolean,
      required: false,
      default: false
    },
    phpURL: { // The URL of the PHP to send the request to
      type: String,
      required: true
    },
    sendValue: { // The parent function that manages sending the data to the chart
      type: Function,
      required: true
    },
    parentRefresh: { // The parent refresh function. Only needed if the parent needs to send a fail input.
      type: Function,
      required: false,
      default: null
    },
    phpParams: { // The Params to send with the request (start and end are auto added)
      type: Object,
      required: false,
      default: function () {
        return {}
      }
    },
    updateOnStart: { // Wether to update on mount or to let the parent call the update method.
      type: Boolean,
      required: false,
      default: true
    }
  },
  data: function () {
    return {
      isLoading: true,
      loadFailed: false,
      dialog: false,
      alltime: true,
      range: []
    }
  },
  mounted () {
    this.isLoading = true
    this.loadFailed = this.failed

    if (this.updateOnStart) {
      this.update()
    }
  },
  watch: {
    failed: function (val) {
      this.loadFailed = val
    }
  },
  components: {
    'date-range': DateRange
  },
  methods: {
    update () {
      this.isLoading = true
      this.loadFailed = false
      var self = this
      var phpParams = JSON.parse(JSON.stringify(this.phpParams))

      if (!this.alltime) {
        var start = this.range[0]
        var end = this.range[1]
        phpParams.start = start
        phpParams.end = end
      }

      // Make a request to the PHP
      axios.get(self.phpURL, {
        params: phpParams
      })
      .then(function (response) {
        // If successful, just send back the response to the parent.
        self.sendValue(response)
      })
      .catch(function (error) {
        // If not, log the error and start a loadFailed state
        self.loadFailed = true
        console.error(error)
      })
      .then(function () {
        // In both cases stop loading as the request has ended
        self.isLoading = false
      })
    },
    refresh (parentFail) {
      if (parentFail) { // We call this function with this.failed as a param (the parent's failed input)
        if (this.parentRefresh != null) {
          this.parentRefresh() // If that's the case, just call the parent's refresh method
        } else {
          console.error('No parent refresh function was attributed')
        }
      } else {
        this.update() // Else, just try again
      }
    },
    childUpdate (val) { // Manages the data received from the DateTimeRange module
      if (typeof val === 'boolean') { // The alltime check was changed
        this.alltime = val
        this.update()
      } else { // The range was changed
        this.range = val
        this.update()
      }
    }
  }
}
</script>

<style scoped>
.overflow {
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Misc/GlobalChart.vue